<template>
  <div class="container">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <div class="content c-top">
      <div class="bread-small">
        <span style="font-size: 18px; font-weight: bold; margin-right: 7px">商城管理</span>
        <span>/</span>
        <span style="
              margin-left: 6px;
              margin-right: 20px;
              cursor: pointer;
              color: #909099;
            " @click="toPage">商城装修</span>
        <span class="bread-active" style="cursor: pointer">首页装修</span>
      </div>
      <div class="page-content">
        <div class="modul">
          <div style="margin-bottom: 18px; margin-top: 3px">功能模块</div>
          <div class="modul-item" v-for="(item, index) in modulList" :key="index" @click="addModul(index)">
            <img src="../../../assets/icon_add_blue@2x.png" alt="" class="addicon" />
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="phone-view">
          <div class="phone-scroll">
            <template v-for="(item, index) in viewData">
              <!-- 搜索模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 1">
                <div class="phone-search">
                  <div class="search-left">
                    <img src="../../../assets/icon_search_36red@2x.png" class="search-icon" alt="" />
                    <p>请输入搜索内容</p>
                  </div>
                  <div class="search-btn">{{ item.modelDetail.navName || '搜索' }}</div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 轮播图模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 2">
                <div class="swiper-box"
                  :style="{ height: item.radioHeight == '2' && item.height ? item.height + 'px' : '124px' }">
                  <el-carousel indicator-position="none" arrow="never"
                    :height="item.radioHeight == '2' && item.height ? item.height + 'px' : '124px'">
                    <el-carousel-item v-for="(sItem, sIndex) in item.modelDetail
                      .swiperImageList" :key="sIndex">
                      <img v-if="sItem.imgUrl" :src="sItem.imgUrl" class="swiper-img" alt="" />
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 分类导航模块 -->
              <div class="pr" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 3">
                <div class="two-num" :style="{
                  'justify-content':
                    item.modelDetail.categoryNavList.length == 2
                      ? 'space-around'
                      : '',
                }">
                  <div class="two-num-item" :style="{
                    flex:
                      item.modelDetail.categoryNavList.length == 2
                        ? 'flex'
                        : '',
                    width:
                      item.modelDetail.categoryNavList.length >= 5
                        ? '20%'
                        : '',
                  }" v-for="(itemx, indexx) in item.modelDetail.categoryNavList" :key="indexx">
                    <img :src="itemx.imgUrl ||
                      require('../../../assets/img_pic3@2x.png')
                      " alt="" class="nav-img" />
                    <p>
                      {{
                        itemx.categoryNavName
                        ? itemx.categoryNavName
                        : "分类导航" + (indexx + 1)
                      }}
                    </p>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 图片导航模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 4">
                <div class="active-box">
                  <div class="one-img">
                    <img :src="itemx.imgUrl ||
                      require('../../../assets/img_pic2@2x.png')
                      " alt="" class="active-img" v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx" />
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 标题模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 5">
                <div class="title-box" :style="{
                  'justify-content':
                    item.modelDetail.showType == 2 ? 'center' : '',
                }">
                  <div class="main-title">
                    {{ item.modelDetail.mainTitle || "主标题" }}
                  </div>
                  <div class="secondary-title">
                    {{ item.modelDetail.subTitle || "" }}
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 活动导航模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 6">
                <div class="active-box">
                  <template v-for="itemx in item.modelDetail.activityNavList">
                    <div class="one-img" style="margin-bottom: 10px" v-if="itemx.showType == 1">
                      <img :src="itemx.imgUrl ||
                        require('../../../assets/img_pic2@2x.png')
                        " alt="" class="active-img" style="height: auto" />
                      <p style="text-align: center;font-size: 12px;">{{ itemx.navModel.activeName }}</p>
                    </div>
                    <div class="two-img" style="margin-bottom: 10px;height: auto;" v-else>
                      <div class="two-img-box" style="margin-right: 5px;height: auto;">
                        <img :src="itemx.imgUrl ||
                          require('../../../assets/img_pic2@2x.png')
                          " alt="" class="active-img" style="height: 84px;" />
                        <p style="text-align: center;font-size: 12px;">{{ itemx.navModel.activeName }}</p>
                      </div>
                      <div class="two-img-box" style="height: auto;">
                        <img :src="itemx.children[0].imgUrl ||
                          require('../../../assets/img_pic2@2x.png')
                          " alt="" class="active-img" style="height: 84px;" />
                        <p style="text-align: center;font-size: 12px;">{{ itemx.children[0].navModel.activeName }}</p>
                      </div>
                    </div>
                  </template>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 商品模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 7">
                <div class="phone-goods">
                  <div class="phone-goods-item" v-for="itemx in item.modelDetail.goodsList">
                    <img :src="itemx.imgUrl" alt="" class="phone-goods-img" />
                    <div class="phone-goods-title">{{ itemx.goodsName }}</div>
                    <div class="phone-goods-price">
                      <p class="retail-price">
                        <span style="font-size: 10px">￥</span>{{ itemx.retailPrice }}
                      </p>
                      <p class="market-price">￥{{ itemx.marketPrice }}</p>
                    </div>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
            </template>
          </div>
        </div>
        <div class="page-right" v-if="viewData.length > 0 && viewIndex > -1">
          <span class="edit-title">内容编辑</span>
          <div class="line"></div>
          <div class="edit-top">
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 1">
              搜索框设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 2">
              轮播图设置
              <span style="color: #909099; font-weight: 500">（最多可上传10张轮播图）</span>
            </div>

            <div class="edit-name" v-if="viewData[viewIndex].modelType == 3">
              分类导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，大小94*94px，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 5">
              标题导航设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 4">
              图片导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，宽度尺寸建议684px，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 6">
              活动专区导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 7">
              商品导航设置
            </div>
            <el-button v-if="viewData[viewIndex].modelType == 2 ||
              viewData[viewIndex].modelType == 3 ||
              viewData[viewIndex].modelType == 4 ||
              viewData[viewIndex].modelType == 6
              " type="primary" @click="addNav(viewIndex, viewData[viewIndex].modelType)">添加导航</el-button>
          </div>
          <div style="margin-bottom: 18px;color: #606266;">
            <span style="font-size: 14px;">模块间距：</span>
            <el-input style="width:300px;" size="mini" v-model="viewData[viewIndex].margin"
              placeholder="请输入间距大小（不输入选择默认高度）单位px"></el-input>
          </div>
          <div class="edit-name" style="margin-bottom:20px;" v-if="viewData[viewIndex].modelType == 2">
            <el-radio v-model="viewData[viewIndex].radioHeight" label="1">标准高度</el-radio>
            <el-radio v-model="viewData[viewIndex].radioHeight" label="2">自定义高度</el-radio>
            <el-input v-if="viewData[viewIndex].radioHeight == '2'" v-model="viewData[viewIndex].height" size="mini"
              style="width:120px;" placeholder="请输入高度 px"></el-input>
          </div>
          <!-- 搜索框模块 -->
          <div v-if="viewData[viewIndex].modelType == 1">
            <el-form>
              <el-form-item label="导航名称：" label-width="100px">
                <el-input placeholder="请输入导航名称" maxlength="6" v-model="viewData[viewIndex].modelDetail.navName"
                  style="width:200px;" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="关联页面：" label-width="100px">
                <div style="
                      width: 442px;
                      height: 36px;
                      background: #e9ecfe;
                      color: #2d46ee;
                      line-height: 36px;
                      padding-left: 10px;
                    " @click="
                      showDialog(
                        viewIndex,
                        0,
                        viewData[viewIndex].modelDetail.navModel.navType,
                        viewData[viewIndex].modelDetail.navModel.goodsSelectedId
                      )
                      ">
                  {{ viewData[viewIndex].modelDetail.navModel.funcName }}
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 轮播图模块 -->
          <div v-if="viewData[viewIndex].modelType == 2">
            <el-table :data="viewData[viewIndex].modelDetail.swiperImageList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column type="index" label="排序" width="70"></el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <el-input placeholder="请输入内容" v-model="scope.row.imgName"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">{{ (scope.row.navModel.navType == 2 && classifyType == '2' &&
                    scope.row.navModel.labelId) ? '分类标签' : '分类类目' }}</p>
                  <p v-if="scope.row.navModel.navType == 3">商品</p>
                  <p v-if="scope.row.navModel.navType == 4">页面设置</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.swiperImageList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分类导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 3">
            <el-table :data="viewData[viewIndex].modelDetail.categoryNavList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column type="index" label="排序" width="70"></el-table-column>
              <el-table-column label="图标" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <el-input placeholder="请输入内容" v-model="scope.row.categoryNavName"></el-input>
                </template>
              </el-table-column>

              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">{{ (scope.row.navModel.navType == 2 && classifyType == '2' &&
                    scope.row.navModel.labelId) ? '分类标签' : '分类类目' }}</p>
                  <p v-if="scope.row.navModel.navType == 3">商品</p>
                  <p v-if="scope.row.navModel.navType == 4">页面设置</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.categoryNavList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 图片导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 4">
            <el-table :data="viewData[viewIndex].modelDetail.imgList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column type="index" label="排序" width="70"></el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">{{ (scope.row.navModel.navType == 2 && classifyType == '2' &&
                    scope.row.navModel.labelId) ? '分类标签' : '分类类目' }}</p>
                  <p v-if="scope.row.navModel.navType == 3">商品</p>
                  <p v-if="scope.row.navModel.navType == 4">页面设置</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.imgList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 标题导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 5">
            <el-form>
              <el-form-item label="主标题名称" label-width="100px" size="small">
                <el-input placeholder="请输入主标题名称" v-model="viewData[viewIndex].modelDetail.mainTitle" style="width: 300px"
                  show-word-limit maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="显示方式" label-width="100px" size="small">
                <el-radio v-model="viewData[viewIndex].modelDetail.showType" :label="1">居左</el-radio>
                <el-radio v-model="viewData[viewIndex].modelDetail.showType" :label="2">居中</el-radio>
              </el-form-item>
              <el-form-item label="副标题名称" label-width="100px" size="small">
                <el-input placeholder="请输入副标题名称" v-model="viewData[viewIndex].modelDetail.subTitle" style="width: 300px"
                  show-word-limit maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="关联页面" label-width="100px" size="small" style="margin-top: 20px">
                <div style="
                      width: 442px;
                      height: 36px;
                      background: #e9ecfe;
                      color: #2d46ee;
                      line-height: 36px;
                      padding-left: 10px;
                    " @click="
                      showDialog(
                        viewIndex,
                        0,
                        viewData[viewIndex].modelDetail.navModel.navType,
                        viewData[viewIndex].modelDetail.navModel.goodsSelectedId
                      )
                      ">
                  {{ viewData[viewIndex].modelDetail.navModel.funcName }}
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 活动导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 6 && expandAll">
            <el-table :data="viewData[viewIndex].modelDetail.activityNavList" row-key="id" default-expand-all
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :header-cell-style="{
                background: '#F5F6FA',
                color: '#303033',
                'font-weight': 'bold',
                'text-align': 'left',
              }">
              <el-table-column label="排序" width="80px">
                <template slot-scope="scope" v-if="scope.row.showType < 3">
                  <p>{{ scope.row.id }}</p>
                </template>
              </el-table-column>
              <el-table-column label="排版类型" width="150px">
                <template slot-scope="scope">
                  <div v-if="scope.row.showType < 3">
                    <el-select v-model="scope.row.showType" placeholder="请选择"
                      @change="getShowType($event, viewIndex, scope.row.id)">
                      <el-option label="一栏" :value="1"></el-option>
                      <el-option label="两栏" :value="2"></el-option>
                    </el-select>
                  </div>
                  <p v-if="scope.row.showType == 3">子类</p>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot="header">
                  <el-popover placement="bottom-end" width="250" trigger="hover" style="overflow: hidden; padding: 0"
                    visible-arrow="false">
                    <div class="active-pic-tips">
                      <p class="active-pic-title">一栏（高度不限制）</p>
                      <div class="onegag">
                        <p>建议尺寸</p>
                        <p>686*168px</p>
                      </div>
                      <!-- <img src="../../../assets/img_pic3@2x (1).png" style="width:230px;height:54px;" alt=""> -->
                      <p class="active-pic-title">两栏</p>
                      <div style="display: flex; justify-content: space-between">
                        <div class="onegag twogag">
                          <p>建议尺寸</p>
                          <p>338*168px</p>
                        </div>
                        <div class="onegag twogag">
                          <p>建议尺寸</p>
                          <p>338*168px</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex; align-items: center" slot="reference">
                      <p>图片</p>
                      <img style="width: 18px; height: 18px" src="../../../assets/icon/icon_qipao.png" />
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.row)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">{{ (scope.row.navModel.navType == 2 && classifyType == '2' &&
                    scope.row.navModel.labelId) ? '分类标签' : '分类类目' }}</p>
                  <p v-if="scope.row.navModel.navType == 3">商品</p>
                  <p v-if="scope.row.navModel.navType == 4">页面设置</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.row,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="活动名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.navModel.activeName" placeholder="请输入名称" maxlength="8"
                    show-word-limit></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.row.id - 1 <
                    viewData[viewIndex].modelDetail.activityNavList.length -
                    1 && scope.row.showType != 3
                    " @click="toTableDown(viewIndex, scope.row.id)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer"
                    v-if="scope.$index > 0 && scope.row.showType != 3"
                    @click="toTabelUp(viewIndex, scope.row.id)">上移</span>
                  <span style="color: red; cursor: pointer"
                    @click="tableDel(viewIndex, scope.row.id, scope.row)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 商品导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 7">
            <div style="display: flex; align-items: center">
              <p style="font-size: 14px; margin-right: 8px">商品类型</p>
              <el-button type="primary" @click="showGoodsDialog(viewIndex)">选择商品</el-button>
            </div>
            <div v-if="viewData[viewIndex].modelDetail.goodsList.length > 0">
              <el-table :data="viewData[viewIndex].modelDetail.goodsList">
                <el-table-column type="index" label="排序" width="80px"></el-table-column>
                <el-table-column label="商品图片" width="100px">
                  <template slot-scope="scope">
                    <img :src="scope.row.imgUrl" style="width: 64px; height: 64px" />
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="goodsName"></el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                  <template slot-scope="scope">
                    <span style="
                          margin-right: 12px;
                          color: #2d46ee;
                          cursor: pointer;
                        " v-if="scope.$index <
                          viewData[viewIndex].modelDetail.goodsList.length - 1
                          " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                    <span style="
                          margin-right: 12px;
                          color: #2d46ee;
                          cursor: pointer;
                        " v-if="scope.$index > 0" @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                    <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box">
        <div class="bottom-btn" @click="saveIndexTemplate">保存</div>
      </div>
    </div>
    <el-dialog title="功能选择" :append-to-body="true" :visible.sync="dialogVisible" width="898">
      <div class="function-box">
        <div class="function-left">
          <div class="function-item" :class="{ 'function-item-active': functionIndex == index }"
            v-for="(item, index) in functionLeft" :key="index" @click="selectFunction(index)">
            <span>{{ item }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="function-right">
          <div class="nopage" v-if="functionIndex == 0">
            <div class="select-box select-box-active">
              <el-radio v-model="radio" label="1">不关联页面</el-radio>
            </div>
          </div>
          <div class="nopage" v-if="functionIndex == 1">
            <div class="select-box" :class="{ 'select-box-active': item.label == functionInletRadio }"
              v-for="item in functionInlet">
              <el-radio v-model="functionInletRadio" :label="item.label">{{
                item.name
              }}</el-radio>
            </div>
          </div>
          <!-- 分类标签 -->
          <div class="nopage" v-if="functionIndex == 2 && classifyType == '2'">
            <div style="display: flex; margin-bottom: 30px;">
              <input type="text" class="search-ipt" v-model="tagName" placeholder="请输入标签名称" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="getLabelList">查询</el-button>
            </div>
            <div class="select-box" :class="{ 'select-box-active': item.id == labelId }" v-for="item in labelList">
              <el-radio v-model="labelId" :label="item.id">{{
                item.tagName
              }}</el-radio>
            </div>
            <div class="pagibox" style="position: static;justify-content: center;margin-top: 20px;">
              <el-pagination @size-change="handleSizeChangeLabel" @current-change="handleCurrentChangeLabel"
                :current-page="labelPageNo" :page-sizes="[5, 10, 20, 30]" :page-size="labelPageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 分类类目 -->
          <div class="nopage" v-if="functionIndex == 2 && classifyType == '1'">
            <div style="display: flex">
              <input type="text" class="search-ipt" v-model="categoryName" placeholder="请输入类目名称" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="searchCate">查询</el-button>
            </div>
            <div class="categary-box">
              <div class="categary-item" :class="{ 'categary-active': item.id == rootCategoryId }"
                v-for="(item, index) in rootCategory" :key="index" @click="swicthRootCate(item.id, item.name)">
                {{ item.name }}
              </div>
            </div>
            <div style="height: 72%; overflow-y: auto">
              <div class="select-box" :class="{ 'select-box-active': item.id == categoryId }"
                v-for="(item, index) in category" :key="item.id" @click="swicthCate(item.id, item.name)">
                <el-radio v-model="categoryId" :label="item.id">{{
                  item.name
                }}</el-radio>
              </div>
            </div>
            <div class="pagibox" style="position: static">
              <el-pagination @size-change="handleSizeChangecate" @current-change="handleCurrentChangecate"
                :current-page="catePageNo" :page-sizes="[5, 10, 20, 30]" :page-size="catePageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="cateTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 商品 -->
          <div class="nopage" style="position: relative; width: 100%; height: 100%" v-if="functionIndex == 3">
            <div style="display: flex; margin-bottom: 18px">
              <input type="text" class="search-ipt" v-model="goodsInfo" placeholder="请输入商品名称/商品编号" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="searchGoods">查询</el-button>
            </div>
            <div style="height: 83%; overflow-y: auto">
              <div class="select-box select-goods" :class="{
                'select-box-active': item.goodsId == goodsSelectedId,
              }" v-for="item in goodsList" @click="getGoodsName(item.goodsName)">
                <el-radio v-model="goodsSelectedId" :label="item.goodsId">
                  <div class="goods-box">
                    <img :src="item.imgUrl" alt="" class="goods-img" />
                    <div>
                      <p>{{ item.goodsName }}</p>
                      <p class="goods-num">商品编号：{{ item.goodsNo }}</p>
                    </div>
                  </div>
                </el-radio>
              </div>
            </div>
            <div class="pagibox" style="position: static">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="goodsPageNo" :page-sizes="[5, 10, 20, 30]" :page-size="goodsPageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 页面设置 -->
          <div class="nopage" v-if="functionIndex == 4">
            <div style="display: flex; margin-bottom: 30px;">
              <input type="text" class="search-ipt" v-model="searchForm.title" placeholder="请输入页面标题" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="searchForm.pageNo = 1; getPageList()">查询</el-button>
            </div>
            <div class="select-box" :class="{ 'select-box-active': item.id == pageId }" v-for="item in pageList">
              <el-radio v-model="pageId" :label="item.id">{{
                item.title
              }}</el-radio>
            </div>
            <div class="pagibox" style="position: static;justify-content: center;margin-top: 20px;">
              <el-pagination @size-change="handleSizeChangePage" @current-change="handleCurrentChangePage"
                :current-page="searchForm.pageNo" :page-sizes="[5, 10, 20, 30]" :page-size="searchForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pageTotalNum">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmFn">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="goodsDialogVisible" width="900px">
      <div slot="title">选择商品</div>
      <div>
        <div style="
              display: flex;
              margin-bottom: 18px;
              position: absolute;
              right: 24px;
              top: 70px;
              z-index: 99;
            ">
          <input type="text" class="search-ipt" style="width: 300px" v-model="goodsInfo" placeholder="请输入商品名称/商品编号" />
          <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
            @click="searchGoods">查询</el-button>
        </div>
        <el-table :data="goodsList" style="width: 100%" ref="goodsTable" @selection-change="handleSelectionChange">
          <el-table-column type="selection" label="全选" width="55">
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; height: 48px">
                <img :src="scope.row.imgUrl" alt="" style="width: 48px; height: 48px; margin-right: 8px" />
                <div style="
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                    ">
                  <p>{{ scope.row.goodsName }}</p>
                  <p class="goods-num">商品编号：{{ scope.row.goodsNo }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagibox" style="position: static">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="goodsPageNo"
          :page-sizes="[5, 10, 20, 30]" :page-size="goodsPageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="goodsTotalNum">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goodsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goodsConfirmFn">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="delDialogVisible" width="600px">
      <div slot="title">
        <i class="el-icon-warning" style="color: red"></i>
        提示信息
      </div>
      <div>删除后不可恢复数据，是否继续？</div>
      <div slot="footer">
        <el-button @click="delDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteViewFn()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import toolBar from '../../../components/toolBar.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    toolBar,
    uploadPicture
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '商城管理', path: '', type: '0' },
          { title: '首页装修', path: '', type: '1' }
        ]
      },
      popData: [
        {
          imgUrl: '',
          navType: 0,
          funcName: '',
          navUrl: '',
          id: ''
        }
      ],
      dialogVisible: false,
      delDialogVisible: false,
      functionLeft: ['无', '功能入口', '分类类目', '商品', '页面设置'],
      functionIndex: 0,
      radio: '1',
      functionInlet: [
        //   { label: '1', name: '消息中心' },
        //   { label: '2', name: '佣金管理' },
        { label: '3', name: '地址管理' },
        //   { label: '4', name: '银行卡' },
        //   { label: '5', name: '店铺申请' },
        //   { label: '6', name: '粉丝管理' },
        { label: '7', name: '联系客服' },
        //   { label: '8', name: '会员中心' },
        { label: '9', name: '优惠券' }
      ],
      functionInletRadio: '',
      modulList: ['搜索功能', '轮播图', '分类导航', '图片导航', '标题导航', '活动导航', '商品导航'],
      nav: [1, 2, 3, 4],
      viewData: [],
      delIndex: 0,
      viewIndex: 0,
      goodsPageNo: 1,
      goodsPageSize: 10,
      goodsSelectedId: null,
      goodsInfo: '',
      goodsTotalNum: 0,
      goodsList: [],
      catePageNo: 1,
      catePageSize: 10,
      categoryName: '',
      cateTotalNum: 0,
      rootCategoryId: '',
      categoryId: '',
      rootCategory: [],
      category: [],
      imageUrl: '',
      rowIndex: 0,
      pageName: '',
      goodsDialogVisible: false,
      selectedGoods: [],
      activeRow: {},
      pid: null,
      radioHeight: '1',
      classifyType: '1',
      labelPageNo: 1,
      labelPageSize: 10,
      tagName: '',
      labelTotalNum: 0,
      labelList: [],
      labelId: null,
      searchForm: {
        title: '', // 	否 	string 	账号名称名称
        status: true,
        createdTimeStart: '',
        createdTimeEnd: '',
        pageNo: 1,
        pageSize: 10
      },
      pageList: [],
      pageTotalNum: 0,
      pageId: null,
      expandAll: true
    }
  },
  created() {
    this.getIndexTemplate()
    this.getLayoutType()
    this.getLabelList()
    this.getGoodsPage()
    this.getRootCategoryList()
    this.getPageList()
  },
  methods: {
    getPageList() {
      this.axios.post('/sys/customerPages/page', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.pageList = res.data.list;
            this.pageTotalNum = res.data.totalNum;
          }
        })
    },
    handleSizeChangePage(e) {
      this.searchForm.pageSize = e;
      this.searchForm.pageNo = 1;
      this.getPageList()
    },
    handleCurrentChangePage(e) {
      this.searchForm.pageNo = e;
      this.getPageList()
    },
    handleSizeChangeLabel(e) {
      this.labelPageSize = e;
      this.labelPageNo = 1;
      this.getLabelList()
    },
    handleCurrentChangeLabel(e) {
      this.labelPageNo = e;
      this.getLabelList()
    },
    getLabelList() {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize,
        tagName: this.tagName,
        status: true
      }
      this.axios.post('/tags/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.labelList = res.data.list;
            this.labelTotalNum = res.data.totalNum
          }
        })
    },
    getLayoutType() {
      this.axios.get('/sys/index/getLayoutType')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.classifyType = res.data + '';
            if (this.classifyType == '1') {
              this.functionLeft[2] = '分类类目'
            } else if (this.classifyType == '2') {
              this.functionLeft[2] = '分类标签'
            }
          }
        })
    },
    saveIndexTemplate() {
      console.log(this.viewData)
      let data = {
        id: this.pid,
        modelJson: JSON.stringify(this.viewData)
      }
      this.axios.post('/sys/index/saveIndexTemplate', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.getIndexTemplate()
            this.$message.success('保存成功')
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    goodsConfirmFn() {
      if (this.selectedGoods.length > 0) {
        this.viewData[this.viewIndex].modelDetail.goodsList = this.viewData[this.viewIndex].modelDetail.goodsList.concat(this.selectedGoods)
        this.viewData[this.viewIndex].modelDetail.goodsList = this.removeArray(this.viewData[this.viewIndex].modelDetail.goodsList, 'goodsId')
        this.viewData[this.viewIndex].modelDetail.idList = this.viewData[this.viewIndex].modelDetail.goodsList.map(item => {
          return item.goodsId
        })
        console.log(this.viewData)
      }
      this.goodsDialogVisible = false
    },
    showGoodsDialog(viewIndex) {
      this.goodsDialogVisible = true;
      this.viewIndex = viewIndex;
      this.goodsInfo = ''
      this.searchGoods()
    },
    removeArray(arr, key) {
      let temp = [];
      arr.forEach(function (a) {
        var check = temp.every(function (b) {
          return a[key] !== b[key];
        })
        check ? temp.push(a) : ''
      })
      return temp;
    },
    handleSelectionChange(e) {
      this.selectedGoods = e;
    },
    getShowType(e, viewIndex, rowIndex) {
      //console.log(e)showType
      let changeIndex = Number(this.viewIndex + '')
      this.viewIndex = -1
      rowIndex = rowIndex - 1;
      if (e == 1) {

        if (this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children) {
          delete this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children
        }

      }
      if (e == 2) {
        let navModel = {
          navType: 0, //1-功能跳转，2-分类标签，3-商品
          funcName: '无',
          navUrl: '',
          id: null //功能、分类或商品id
        }
        console.log(rowIndex)
        console.log('这是id=', this.viewData[viewIndex].modelDetail.activityNavList)
        // return
        let children = [{
          id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 10,
          showType: 3,
          imgUrl: '',
          navModel: navModel
        }]
        this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children = children;
        // if(!this.viewData[viewIndex].modelDetail.activityNavList[rowIndex + 1] || this.viewData[viewIndex].modelDetail.activityNavList[rowIndex + 1].showType != 3){
        //     this.viewData[viewIndex].modelDetail.activityNavList.splice(rowIndex + 1,0,data)
        // }
      }
      this.viewData[viewIndex].modelDetail.activityNavList = JSON.parse(JSON.stringify(this.viewData[viewIndex].modelDetail.activityNavList))
      this.$forceUpdate()
      this.$nextTick(() => {
        this.viewIndex = changeIndex
      })
      let arr = this.viewData[viewIndex].modelDetail.activityNavList
      console.log(arr)
    },
    addNav(viewIndex, modelType) {
      //modelType==1-搜索功能，2-轮播图，3-分类导航，4-图片导航，5-标题导航，6-活动导航，7-商品导航
      let navModel = {
        navType: 0, //1-功能跳转，2-分类标签，3-商品
        funcName: '无',
        navUrl: '',
        id: null //功能、分类或商品id
      }
      if (modelType == 2) {
        if (this.viewData[this.viewIndex].modelDetail.swiperImageList.length == 10) {
          this.$message.warning('最多只能添加10张图片')
          return
        }
        let data = {
          imgName: '',
          imgUrl: '',
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.swiperImageList.push(data)
      }
      if (modelType == 3) {
        let data = {
          categoryNavName: '',
          imgUrl: '',
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.categoryNavList.push(data)
      }
      if (modelType == 4) {
        let data = {
          imgUrl: '',
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.imgList.push(data)
      }
      if (modelType == 6) {
        let idx = this.viewData[this.viewIndex].modelDetail.activityNavList.length - 1;
        let data = {
          id: this.viewData[this.viewIndex].modelDetail.activityNavList.length > 0 ? this.viewData[this.viewIndex].modelDetail.activityNavList[idx].id + 1 : 1,
          imgUrl: '',
          showType: 1,
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.activityNavList.push(data)
      }
    },
    confirmFn() {
      let funcName = '无';
      let rootCategoryId = '';
      let categoryId = '';
      let goodsSelectedId = '';
      if (this.functionIndex == 0) {
        funcName = '无'
      } else if (this.functionIndex == 1) {
        // { label: '1', name: '消息中心' },
        // { label: '2', name: '佣金管理' },
        // { label: '3', name: '地址管理' },
        // { label: '4', name: '银行卡' },
        // { label: '5', name: '店铺申请' }
        if (this.functionInletRadio == '1') {
          funcName = '消息中心'
        }
        if (this.functionInletRadio == '2') {
          funcName = '佣金管理'
        }
        if (this.functionInletRadio == '3') {
          funcName = '地址管理'
        }
        if (this.functionInletRadio == '4') {
          funcName = '银行卡'
        }
        if (this.functionInletRadio == '5') {
          funcName = '店铺申请'
        }
        if (this.functionInletRadio == '6') {
          funcName = '粉丝管理'
        }
        if (this.functionInletRadio == '7') {
          funcName = '联系客服'
        }
        if (this.functionInletRadio == '8') {
          funcName = '会员中心'
        }
        if (this.functionInletRadio == '9') {
          funcName = '优惠券'
        }
      } else if (this.functionIndex == 2) {
        if (this.classifyType == '1') {
          funcName = this.pageName;
          rootCategoryId = this.rootCategoryId;
          categoryId = this.categoryId;
        }
        if (this.classifyType == '2') {
          this.labelList.forEach(item => {
            if (item.id == this.labelId) {
              funcName = item.tagName
            }
          })
          // console.log('funcName',this.labelList)
        }
      } else if (this.functionIndex == 3) {
        goodsSelectedId = this.goodsSelectedId;
        this.goodsList.forEach((item) => {
          if (this.goodsSelectedId === item.goodsId) {
            funcName = item.goodsName.substring(0, 8) + '...'
          }
        })
        // funcName = this.pageName;
      } else if (this.functionIndex == 4) {
        this.pageList.forEach((item) => {
          if (this.pageId === item.id) {
            funcName = item.title
          }
        })
      }
      if (this.viewData[this.viewIndex].modelType == 1) {//搜索框模块
        this.viewData[this.viewIndex].modelDetail.navModel.funcName = funcName
        this.viewData[this.viewIndex].modelDetail.navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.navModel.pageId = this.pageId;
      }
      if (this.viewData[this.viewIndex].modelType == 2) {//轮播图模块
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.funcName = funcName
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.pageId = this.pageId;
      }
      if (this.viewData[this.viewIndex].modelType == 3) {//分类导航模块categoryNavList
        console.log('rowIndex', this.rowIndex)
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.funcName = funcName
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.pageId = this.pageId;
      }
      if (this.viewData[this.viewIndex].modelType == 4) {//图片导航模块
        console.log('rowIndex', this.rowIndex)
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.funcName = funcName
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageId = this.pageId;
      }
      if (this.viewData[this.viewIndex].modelType == 5) {//标题导航模块
        this.viewData[this.viewIndex].modelDetail.navModel.funcName = funcName
        this.viewData[this.viewIndex].modelDetail.navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.navModel.pageId = this.pageId;
      }
      if (this.viewData[this.viewIndex].modelType == 6) {//活动导航模块
        if (this.activeRow.showType < 3) {
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.funcName = funcName
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.navType = this.functionIndex;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.rootCategoryId = rootCategoryId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.categoryId = categoryId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.goodsSelectedId = goodsSelectedId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.functionInletRadio = this.functionInletRadio;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.labelId = this.labelId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId = this.pageId;
        } else {
          console.log('this.activeRow.id==', this.activeRow.id)
          let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
            return item.children && item.children[0].id == this.activeRow.id
          })
          console.log('arr==', arr)
          arr[0].children[0].navModel.funcName = funcName
          arr[0].children[0].navModel.navType = this.functionIndex;
          arr[0].children[0].navModel.rootCategoryId = rootCategoryId;
          arr[0].children[0].navModel.categoryId = categoryId;
          arr[0].children[0].navModel.goodsSelectedId = goodsSelectedId;
          arr[0].children[0].navModel.functionInletRadio = this.functionInletRadio;
          arr[0].children[0].navModel.labelId = this.labelId;
          arr[0].children[0].navModel.pageId = this.pageId;
        }
      }
      this.$forceUpdate()
      // console.log(this.viewData[this.viewIndex].modelDetail)
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.rootCategoryId = null;
        this.categoryId = null;
        this.goodsSelectedId = null;
        this.functionInletRadio = null;
      })
    },
    showDialog(viewIndex, rowIndex, navType, goodsId) {
      this.viewIndex = viewIndex;
      if (this.viewData[this.viewIndex].modelType == 6) {
        this.activeRow = rowIndex;
      } else {
        this.rowIndex = rowIndex;
      }
      console.log('navType==', navType)
      this.dialogVisible = true;
      this.functionIndex = navType
      this.selectedGoods = []
      this.goodsSelectedId = goodsId
      if (navType == 1) {//功能入口
        if (this.viewData[this.viewIndex].modelType == 1) {//轮播图
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 4) {//图片导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio
        }

      }
      if (navType == 2) {//分类类目
        console.log(this.viewData[this.viewIndex])
        if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.navModel.labelId || null;
            return
          }
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId
          this.categoryId = this.viewData[this.viewIndex].modelDetail.navModel.categoryId

        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.labelId || null;
            return
          }
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.rootCategoryId
          this.categoryId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.categoryId

        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.rootCategoryId

        }
        if (this.viewData[this.viewIndex].modelType == 4) {//图片导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.rootCategoryId

        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId
        }
        if (this.viewData[this.viewIndex].modelType == 6) {//活动导航
          console.log('rowIndex==', rowIndex)
          if (this.activeRow.showType < 3) {
            console.log(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1])
            if (this.classifyType == '2') {
              this.labelId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.labelId || null;
              return
            }
            this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.categoryId
            this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.rootCategoryId
            this.pageId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId || null;
          } else {
            console.log('this.activeRow.id==', this.activeRow.id)
            let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[0].id == this.activeRow.id
            })

            console.log('arr==', arr)
            if (this.classifyType == '2') {
              this.labelId = arr[0].children[0].navModel.labelId || null;
              return
            }
            this.categoryId = arr[0].children[0].navModel.categoryId;
            this.rootCategoryId = arr[0].children[0].navModel.rootCategoryId
            this.pageId = arr[0].children[0].navModel.pageId || null;

          }
          // if (this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex]) {
          //   this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex].navModel.categoryId
          //   this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex].navModel.rootCategoryId
          // } else {
          //   console.log('5555555', this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1])
          //   this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1].children[0].navModel.categoryId
          //   this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1].children[0].navModel.rootCategoryId
          // }

        }
        this.searchCate()
      }
      if (navType == 4) {
        if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
          this.pageId = this.viewData[this.viewIndex].modelDetail.navModel.pageId;
        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          this.pageId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.pageId || null;
        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.pageId || null;
        }
        if (this.viewData[this.viewIndex].modelType == 4) {//图片导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageId || null;
        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.navModel.pageId || null;
        }
        if (this.viewData[this.viewIndex].modelType == 6) {//活动导航
          if (this.activeRow.showType < 3) {

            this.pageId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId || null;
          } else {
            console.log('this.activeRow.id==', this.activeRow.id)
            let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[0].id == this.activeRow.id
            })

            this.pageId = arr[0].children[0].navModel.pageId || null;

          }
        }
      }

      this.goodsPageNo = 1
      console.log(goodsId)
      let data = {
        pageNo: this.goodsPageNo,
        pageSize: this.goodsPageSize,
        selectedId: this.goodsSelectedId,
        goodsInfo: this.goodsInfo
      }
      this.axios.post('/sys/index/getGoodsPage', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.goodsList = res.data.list;
            this.goodsList.forEach((item) => {
              if (goodsId === item.goodsId) {
                this.getGoodsName(item.goodsName)
              }
            })
          }
        })
      // this.goodsList.forEach((item) => {
      //   if (goodsId === item.goodsId) {
      //     this.getGoodsName(item.goodsName)
      //   }
      // })
      this.$forceUpdate()

    },
    getImage(e, viewIndex, idx) {
      console.log(e, viewIndex, idx)
      if (this.viewData[viewIndex].modelType == 2) {//轮播图模块
        this.viewData[viewIndex].modelDetail.swiperImageList[idx].imgUrl = e;
      }
      if (this.viewData[viewIndex].modelType == 3) {//分类导航模块
        this.viewData[viewIndex].modelDetail.categoryNavList[idx].imgUrl = e;
      }
      if (this.viewData[viewIndex].modelType == 4) {//图片导航模块
        this.viewData[viewIndex].modelDetail.imgList[idx].imgUrl = e;
      }
      if (this.viewData[viewIndex].modelType == 6) {//活动导航模块

        if (idx.showType < 3) {
          this.viewData[viewIndex].modelDetail.activityNavList[idx.id - 1].imgUrl = e;
        } else {
          console.log(444)
          let arr = this.viewData[viewIndex].modelDetail.activityNavList.filter(item => {
            return item.children && item.children[0].id == idx.id
          })
          console.log(arr)
          arr[0].children[0].imgUrl = e;

        }

      }
      this.imageUrl = e;
      console.log(this.viewData)
      this.$forceUpdate()
    },
    getGoodsName(name) {
      this.pageName = name.substring(0, 8) + '...'
    },
    swicthCate(id, name) {
      this.pageName = name;
    },
    swicthRootCate(id, name) {
      this.rootCategoryId = id;
      this.catePageNo = 1;
      this.getCategoryList()
    },
    handleSizeChangecate(e) {
      this.catePageSize = e;
      this.catePageNo = 1;
      this.getCategoryList()
    },
    handleCurrentChangecate(e) {
      this.catePageNo = e;
      this.getCategoryList()
    },
    //获取一级分类列表
    getRootCategoryList() {
      this.axios.get('/sys/index/getRootCategoryList?selectedId=' + this.rootCategoryId)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            let list = res.data;
            let idx = list.findIndex(item => item.selected)
            this.rootCategoryId = this.rootCategoryId ? this.rootCategoryId : list[0].id;
            this.rootCategory = list;
            this.getCategoryList()
          }
        })
    },
    searchCate() {
      this.catePageNo = 1;
      this.getCategoryList()
    },
    //获取二级分类列个表
    getCategoryList() {
      let data = {
        pageNo: this.catePageNo,
        pageSize: this.catePageSize,
        parentId: this.rootCategoryId,
        selectedId: this.categoryId,
        categoryName: this.categoryName
      }
      this.axios.post('/sys/index/getCategoryList', data)
        .then(res => {
          console.log('555', res)
          let list = res.data.list;
          let idx = list.findIndex(item => item.selected)
          if (idx > -1) {
            this.categoryId = list[idx].id;
          }
          this.category = list;
          this.cateTotalNum = res.data.totalNum;
          console.log(this.category)
        })
    },
    handleSizeChange(e) {
      this.goodsPageNo = 1;
      this.goodsPageSize = e;
      this.getGoodsPage()
    },
    handleCurrentChange(e) {
      this.goodsPageNo = e;
      this.getGoodsPage()
    },
    searchGoods() {
      this.goodsPageNo = 1;
      this.getGoodsPage()
    },
    //获取商品列表
    getGoodsPage() {
      let data = {
        pageNo: this.goodsPageNo,
        pageSize: this.goodsPageSize,
        selectedId: '',
        goodsInfo: this.goodsInfo
      }
      this.axios.post('/sys/index/getGoodsPage', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.goodsList = res.data.list;
            this.goodsTotalNum = res.data.totalNum;
            let list = []
            //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
            console.log(this.viewData[this.viewIndex].modelDetail)
            if (this.viewData[this.viewIndex].modelDetail && this.viewData[this.viewIndex].modelDetail.goodsList) {
              this.goodsList.forEach((item) => {
                this.viewData[this.viewIndex].modelDetail.goodsList.forEach(val => {
                  if (val.goodsId === item.goodsId) {
                    // 把判断出来的默认表格数据push到创建的数组中
                    list.push(item)
                  }
                })
              })
              console.log('选中的数组', list)
              if (list.length > 0) {
                //再遍历数组，将数据放入方法中
                this.$nextTick(() => {
                  list.forEach((row) => {
                    this.$refs.goodsTable.toggleRowSelection(row)
                  })
                })

              }
            }

          }
        })
    },
    // 获取首页数据
    getIndexTemplate() {
      this.axios.get('/sys/index/getIndexTemplate')
        .then(res => {
          console.log(res)
          if (res.code === 0) {
            this.pid = res.data.id;
            let modelJson = JSON.parse(res.data.modelJson)


            modelJson.forEach(async item => {
              if (item.modelType == 1) {
                let navModel = {
                  navType: 0, //1-功能跳转，2-分类标签，3-商品
                  funcName: '无',
                  navUrl: '',
                  id: null //功能、分类或商品id
                }
                if (!item.modelDetail.navName) {
                  let data = {
                    navName: '',
                    navModel: navModel
                  }
                  item.modelDetail = data
                }
              }
              if (item.modelType == 7) {
                if (item.modelDetail.idList && item.modelDetail.idList.length > 0) {
                  let goodsList = await this.getGoodsList(item.modelDetail.idList)
                  item.modelDetail.goodsList = goodsList;
                  item.modelDetail.idList = goodsList.map(i => {
                    return i.goodsId
                  })
                }
              }
              if (item.modelType == 2) {
                item.height = item.height ? item.height : '';
                item.radioHeight = item.radioHeight ? item.radioHeight : '1'
              }
              if (item.modelType == 6) {
                // item.activeName
                console.log('活动===', item)
                item.modelDetail.activityNavList.forEach(acItem => {
                  acItem.navModel.activeName = acItem.navModel.activeName ? acItem.navModel.activeName : '';
                  if (acItem.children && acItem.children.length > 0) {
                    acItem.children.forEach(chil => {
                      chil.navModel.activeName = chil.navModel.activeName ? chil.navModel.activeName : '';
                    })
                  }
                })
              }
              item.margin = item.margin ? item.margin : ''
            })
            this.viewData = modelJson;
            this.$forceUpdate()
            console.log(modelJson)
          }
        })
    },
    //根据id获取商品
    async getGoodsList(ids) {
      let res = await this.axios.post('/sys/index/getGoodsList', { idList: ids })
      console.log(res)
      if (res.code == 0) {
        return res.data
      }
    },
    //表格操作
    toTableDown(viewIndex, idx) {
      console.log(this.viewData[viewIndex].modelDetail)
      let array = []
      if (this.viewData[viewIndex].modelType == 2) {
        array = this.viewData[viewIndex].modelDetail.swiperImageList;
      }
      if (this.viewData[viewIndex].modelType == 3) {
        array = this.viewData[viewIndex].modelDetail.categoryNavList;
      }
      if (this.viewData[viewIndex].modelType == 4) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 6) {
        idx = idx - 1;
        array = this.viewData[viewIndex].modelDetail.activityNavList;
      }
      if (this.viewData[viewIndex].modelType == 7) {
        array = this.viewData[viewIndex].modelDetail.goodsList;
      }
      array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
      if (this.viewData[viewIndex].modelType == 6) {
        array[idx].id = array[idx].id - 1;
        array[idx + 1].id = array[idx + 1].id + 1
      }
      if (this.viewData[viewIndex].modelType == 7) {
        this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
          return item.goodsId
        })
      }

      // this.viewData[viewIndex] = JSON.parse(JSON.stringify(this.viewData[viewIndex]))
      // this.$forceUpdate()

    },
    toTabelUp(viewIndex, idx) {
      let array = []
      if (this.viewData[viewIndex].modelType == 2) {
        array = this.viewData[viewIndex].modelDetail.swiperImageList;
      }
      if (this.viewData[viewIndex].modelType == 3) {
        array = this.viewData[viewIndex].modelDetail.categoryNavList;
      }
      if (this.viewData[viewIndex].modelType == 4) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 6) {
        idx = idx - 1;
        array = this.viewData[viewIndex].modelDetail.activityNavList;
      }
      if (this.viewData[viewIndex].modelType == 7) {
        array = this.viewData[viewIndex].modelDetail.goodsList;
      }
      array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
      if (this.viewData[viewIndex].modelType == 6) {
        array[idx].id = array[idx].id + 1;
        array[idx - 1].id = array[idx - 1].id - 1
      }
      if (this.viewData[viewIndex].modelType == 7) {
        this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
          return item.goodsId
        })
      }
    },
    tableDel(viewIndex, idx, row) {
      let array = []
      if (this.viewData[viewIndex].modelType == 2) {
        array = this.viewData[viewIndex].modelDetail.swiperImageList;
      }
      if (this.viewData[viewIndex].modelType == 3) {
        array = this.viewData[viewIndex].modelDetail.categoryNavList;
      }
      if (this.viewData[viewIndex].modelType == 4) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 6) {
        // if (children) {
        idx = idx - 1;
        // }

        array = this.viewData[viewIndex].modelDetail.activityNavList;
      }
      if (this.viewData[viewIndex].modelType == 7) {
        array = this.viewData[viewIndex].modelDetail.goodsList;
      }
      this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.viewData[viewIndex].modelType == 6) {
          console.log(row)
          if (row.showType < 3) {
            array.splice(idx, 1)
          } else {
            console.log(444)
            let arr = this.viewData[viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[0].id == row.id
            })
            console.log(arr)
            arr[0].showType = 1;
            delete arr[0].children

          }
          // if(!children){
          //     console.log(34444)

          // }else{


          // }

          // console.log('children',children,idx)
          this.viewData[viewIndex].modelDetail.activityNavList.forEach((item, index) => {
            item.id = index + 1;
            if (item.children) {
              item.children.forEach((itemx, indexx) => {
                itemx.id = item.id + 10
              })
            }
          })
          this.viewData[viewIndex].modelDetail.activityNavList = JSON.parse(JSON.stringify(this.viewData[viewIndex].modelDetail.activityNavList))
          console.log(this.viewData[viewIndex].modelDetail.activityNavList)
          return
        }
        if (this.viewData[viewIndex].modelType !== 6) {
          array.splice(idx, 1)
        }
        if (this.viewData[viewIndex].modelType == 7) {
          this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
            return item.goodsId
          })
        }

      }).catch(() => {

      });

    },
    // 模块操作条
    toDown(idx) {
      let array = this.viewData;
      array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
      setTimeout(() => {
        this.viewIndex = idx + 1;
        this.toggleBar(idx + 1)
      }, 200)

    },
    toUp(idx) {
      let array = this.viewData;
      array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
      setTimeout(() => {
        this.viewIndex = idx - 1;
        this.toggleBar(idx - 1)
      }, 200)

    },
    toEdit(idx) {
      this.viewIndex = idx;
    },
    toDel(idx) {
      console.log(idx)
      this.delDialogVisible = true;
      this.delIndex = idx;
    },
    deleteViewFn() {
      this.viewData.splice(this.delIndex, 1)
      this.viewIndex = -1;
      this.delDialogVisible = false;
      this.$forceUpdate()
    },
    //鼠标点击模块
    handleView(idx) {
      this.viewIndex = idx
      this.expandAll = false
      // console.log(this.viewData)
      this.toggleBar(idx)
      this.$forceUpdate()
    },
    toggleBar(idx) {
      let timer = setTimeout(()=>{
        console.log(11111)
        this.expandAll = true
      },400)
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showBar1 = true;
          item.showBar2 = true;
        } else {
          item.showBar1 = false;
          item.showBar2 = false;
        }
      })
      this.$forceUpdate()
    },
    //鼠标经过事件
    handleCloseBar(e, idx) {
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showBar1 = false;
        }
      })
    },
    handleShowBar(e, idx) {
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showBar1 = true;
        } else {
          item.showBar1 = false;
        }
      })
    },
    //点击添加功能模块
    addModul(idx) {
      //添加模块功能，先添加modelType确定模块类型，再根据模块类型添加相应的字段
      //1-搜索功能，2-轮播图，3-分类导航，4-图片导航，5-标题导航，6-活动导航，7-商品导航
      this.viewData.forEach(item => {
        item.showBar1 = false;
        item.showBar2 = false;
      })
      let modelType = idx + 1;
      let viewData = {
        modelType: modelType,
        showBar1: true,
        showBar2: true,
        modelOrder: this.viewData.length + 1,//模块排序
        modelDetail: {}, //模块详情
        margin: ''
      }
      let navModel = {
        navType: 0, //1-功能跳转，2-分类标签，3-商品
        funcName: '无',
        navUrl: '',
        id: null //功能、分类或商品id
      }
      if (modelType == 1) {//搜索
        let data = {
          navName: '',
          navModel: navModel
        }
        viewData.modelDetail = data
      } else if (modelType == 2) {//轮播图
        let data = {
          imgName: '',
          imgUrl: '',
          navModel: navModel
        }
        viewData.radioHeight = '1';
        viewData.height = '';
        viewData.modelDetail.swiperImageList = [data]
      } else if (modelType == 3) {//分类导航
        let data = {
          imgUrl: '',
          categoryNavName: '',
          navModel: navModel
        }
        let data2 = JSON.parse(JSON.stringify(data));
        viewData.modelDetail.categoryNavList = [data, data2]
        // setTimeout(()=>{viewData.modelDetail.categoryNavList.push(data)},200)

      } else if (modelType == 4) {// 图片导航
        let data = {
          imgUrl: '',
          navModel: navModel
        }
        viewData.modelDetail.imgList = [data]
      } else if (modelType == 5) {//标题导航
        let data = {
          mainTitle: '',
          subTitle: '',
          showType: 1, //1-居左，2-居中
          navModel: navModel
        }
        viewData.modelDetail = data
      } else if (modelType == 6) { //活动导航
        navModel.activeName = ''
        let data = {
          id: 1,
          showType: 1,// 1-一栏，2-两栏
          imgUrl: '',
          navModel: navModel
        }
        viewData.modelDetail.activityNavList = [data]
      } else {//商品导航
        let data = {
          goodsType: 1,
          idList: [],
          goodsList: []
        }
        viewData.modelDetail = data
      }
      this.viewData.push(viewData)
      console.log(this.viewData)
      this.viewIndex = this.viewData.length - 1;
    },
    selectFunction(idx) {
      this.functionIndex = idx;
    },
    handleClose(e) {

    },
    toPage() {
      this.$router.push('./mallRenovation')
    }


  }


}
</script>
<style lang="scss" scoped>
input[type="text"],
input[type="number"] {
  -webkit-appearance: none;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d8dce5;
  box-sizing: border-box;
  color: #5a5e66;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 1;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;

  &:hover {
    border-color: #b4bccc;
  }

  &:focus {
    border-color: #409EFF;
    outline: 0;
  }
}

.pr {
  width: 100%;
  min-height: 20px;
  position: relative;
  padding: 0 16px;
  box-sizing: border-box;
  cursor: move;
}

.bread-small {
  font-size: 16px;
}

.bread-active {
  color: black;
  border-bottom: 2px solid #2d46ee;
}

.page-content {
  width: 100%;
  display: flex;
  margin-top: 20px;
}

.phone-view {
  width: 375px;
  height: 667px;
  background: #fff;
  border-radius: 16px;
  margin-right: 56px;
  position: relative;
  background-image: url(../../../assets/img_iphone@2x.png);
  background-size: contain;
  background-repeat: no-repeat;
}

.phone-scroll {
  width: 100%;
  height: calc(100% - 88px);
  background-color: transparent;
  margin-top: 85px;
  overflow-y: auto;
  padding-top: 20px;
  box-sizing: border-box;
}

.phone-scroll::-webkit-scrollbar {
  display: none;
}

.phone-masker {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-maskerimg {
  width: 250px;
  height: 300px;
  background-image: url(../../../assets/img_tanchuang@2x.png);
  background-repeat: no-repeat;
  background-size: contain;
}

.page-right {
  width: 1000px;
}

.right-title {
  width: 92px;
  height: 36px;
  background: #2d46ee;
  border-radius: 3px;
  font-size: 16px;
  margin-bottom: 40px;
  text-align: center;
  line-height: 36px;
  color: white;
}

.edit-title {
  font-size: 16px;
  color: #303033;
  font-weight: bold;
}

.line {
  width: 100%;
  height: 1px;
  background-color: #c0c0cc;
  margin: 18px auto;
}

.edit-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.edit-name {
  font-size: 14px;
  font-weight: bold;
}

.addbox {
  width: 64px;
  height: 64px;
  background: #ffffff;
  border: 1px solid #c0c0cc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* margin-left: 20px; */
}

.addicon {
  width: 24px;
  height: 24px;
}

.el-table th>.cell {
  font-size: 14px !important;
  text-align: left !important;
  /* padding-left: 30px !important; */
}

.el-table td {
  text-align: left !important;
}

.toselect {
  width: 100%;
  height: 32px;
  background: #e9ecfe;
  border-radius: 3px;
  line-height: 32px;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #2d46ee;
}

.el-dialog__header {
  border-bottom: none;
}

.el-dialog__body {
  padding-top: 18px;
}

.function-box {
  width: 100%;
  height: 557px;
  display: flex;
  color: #303033;
}

/deep/ .el-radio {
  color: #303033;
}

.function-left {
  width: 198px;
  height: 64px;
  background: #ffffff;
}

.function-right {
  flex: 1;
  height: 557px;
  background: #ffffff;
  border: 1px solid #e9ecfe;
  padding: 18px;
  box-sizing: border-box;
}

.function-item {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  box-sizing: border-box;
  font-size: 16px;
}

.function-item-active {
  background-color: #e9ecfe;
  color: #2d46ee;
}

.select-box {
  width: 100%;
  height: 48px;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 18px;
  box-sizing: border-box;
}

.select-box-active {
  background: #e9ecfe;
}

.search-ipt {
  flex: 1 !important;
  /* width: 518px !important; */
  height: 36px !important;
  background: #ffffff;
  border: 1px solid #c0c0cc;
  border-radius: 3px;
}

.categary-box {
  width: 678px;
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 18px;
  padding-bottom: 18px;
}

.categary-item {
  padding: 8px 15px;
  background-color: #e9ecfe;
  font-size: 14px;
  margin-right: 18px;
  display: inline-block;
  cursor: pointer;
}

.categary-active {
  background-color: #2d46ee;
  color: white;
}

.select-goods {
  height: 72px;
}

.select-goods .el-radio {
  display: flex;
  align-items: center;
}

.goods-box {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.goods-img {
  width: 48px;
  height: 48px;
  background: #d1d1d1;
  margin-right: 8px;
}

.goods-num {
  color: #606066;
  margin-top: 10px;
}

.pagibox {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 6px;
  right: 0;
}

.modul {
  padding: 12px;
  border-radius: 6px;
  color: white;
  background-color: #2d46ee;
  margin-right: 18px;
  height: 565px;
  box-sizing: border-box;
}

.modul-item {
  width: 140px;
  height: 64px;
  background: #e9ecfe;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  margin-bottom: 8px;
  color: #2d46ee;
  cursor: pointer;
  box-sizing: border-box;
}

.addicon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.phone-search {
  width: 100%;
  height: 36px;
  background: #ffffff;
  border: 1px solid #f63c56;
  border-radius: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #cccccc;
  box-sizing: border-box;
}

.search-left {
  display: flex;
  align-items: center;
}

.search-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  margin-left: 10px;
}

.search-btn {
  // width: 58px;
  height: 32px;
  background: #f63c56;
  border-radius: 32px;
  color: white;
  // text-align: center;
  line-height: 32px;
  margin-right: 2px;
  padding: 0 16px;
}

.swiper-box {
  width: 100%;
  height: 124px;
  border-radius: 8px;
  background-color: #c0c0cc;
}

.swiper-img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.mg-bttom {
  margin-bottom: 20px;
}

.title-box {
  display: flex;
  position: relative;
  color: #303033;
}

.main-title {
  font-size: 16px;
  font-weight: bold;
}

.secondary-title {
  font-size: 12px;
  color: #666666;
  position: absolute;
  right: 0;
  top: 2px;
}

.one-img {
  width: 100%;
}

.active-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.two-img {
  display: flex;
  justify-content: space-between;
}

.two-img-box {
  flex: 1;
  height: 84px;
}

.phone-goods {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.phone-goods-item {
  width: 49%;
  height: 253px;
  position: relative;
}

.phone-goods-img {
  width: 100%;
  height: 167px;
  margin-bottom: 8px;
}

.phone-goods-title {
  width: 100%;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phone-goods-price {
  width: 100%;
  position: absolute;
  bottom: 4px;
  left: 0;
  padding: 0 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.retail-price {
  font-size: 16px;
  color: #f63c56;
  font-weight: bold;
}

.market-price {
  font-size: 12px;
  color: #999999;
}

.two-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.two-num-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #060606;
  margin-bottom: 20px;
}

.nav-img {
  width: 47px;
  height: 47px;
  margin-bottom: 8px;
}

/* .pr:hover .tool-bar{
      display: flex;
  } */
.tool-bar {
  height: 31px;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0 8px;
  box-sizing: border-box;
  justify-content: flex-end;
  font-size: 14px;
  color: white;
  z-index: 11;
  /* display: none; */
}

.bar-item {
  display: flex;
  align-items: center;
  margin-left: 14px;
  cursor: pointer;
}

.bar-img {
  width: 18px;
  height: 18px;
}

.nopage {
  height: 100%;
  overflow-y: auto;
}

.active-tipb {
  position: relative;
}

.active-pic-tips {
  width: 250px;
  height: 216px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 18px 10px;
  box-sizing: border-box;
}

.active-pic-title {
  font-size: 14px;
  color: #303033;
  margin-bottom: 8px;
}

.onegag {
  width: 230px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 12px;
  color: #909099;
  background-image: url(../../../assets/img_pic333.png);
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 18px;
}

.twogag {
  width: 113px;
  background-image: url(../../../assets/img_pic4@2x.png);
}

.el-popover {
  overflow: hidden;
  padding: 0;
}

.el-table [class*="el-table__row--level"] .el-table__expand-icon {
  display: none;
}

.bottom-box {
  width: 100%;
  height: 88px;
  border-top: 1px solid #ebebfa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.bottom-btn {
  width: 184px;
  height: 40px;
  background: #2d46ee;
  border-radius: 3px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

/deep/ .el-message-box__status.el-icon-warning {
  color: #f63c56 !important;
}

/deep/ .el-message-box__status::before {
  color: #f63c56 !important;
}
</style>